import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Menhir1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MENHIR1;
}

export default Menhir1PoiTileEntity;
